import { vue } from "../main";
import { timePromise } from "./util";
import axios from "axios";
import { HttpClient } from "./http";
import { menus } from "./menu";

let adminKey = "admin-storage-key";

class LoginState {
    constructor() {
        this.refreshData();
    }

    userToMenus(user) {
        let temp = {};
        menus.map((parent) => {
            parent.submenus.map((child) => {
                if (user.pagePermission.includes(child.path)) {
                    if (temp.hasOwnProperty(parent.text)) {
                        temp[parent.text]["submenus"].push(child);
                    } else {
                        temp[parent.text] = {
                            submenus: [child],
                        };
                    }
                }
            });
        });
        let result = [];
        for (let key in temp) {
            result.push({
                text: key,
                submenus: temp[key].submenus,
            });
        }
        return result
    }

    getUserMenus() {
        if (!this.adminLogined()) return []
        if (this.admin.masterAdmin) return menus
        return this.userToMenus(this.admin)
    }

    getUserInfo() {
        let str = localStorage.getItem(adminKey);
        let result = {}
        if (isJSON(str)) {
            result = JSON.parse(str);
        }
        return result
    }

    refreshData() {
        let item = localStorage.getItem(adminKey);
        if (item) {
            this.admin = JSON.parse(item);
        } else {
            this.admin = null;
        }
    }

    async fetchAdminIfLogin() {
        if (!this.admin) return;
        let res = await HttpClient.post("/restful", {
            model: "Admin",
            cond: this.admin._id,
            populate: "store"
        });

        let item = res.result;
        delete item.password;

        if (item) {
            localStorage.setItem(adminKey, JSON.stringify(item));
            this.refreshData();
        }
    }

    adminLogined() {
        return !!this.admin;
    }

    // 调用登录
    async login({ username, password }) {
        // let [res] = await Promise.all([
        //     axios.post("/admin/login", {
        //         username,
        //         password
        //     }),
        //     timePromise(0.5)
        // ]);
        this.admin = await axios.post("/admin/login", {
            username,
            password
        });
        localStorage.setItem(adminKey, JSON.stringify(this.admin));
    }

    // 调用登出
    logout() {
        localStorage.setItem(adminKey, "");
        this.refreshData();
        vue.$router.replace("/html-login");
    }
}

export const loginState = new LoginState();

function isJSON(str) {
    if (typeof str == "string") {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }
}